import Hero from "./Section/Hero";
import AboutZeuss from "./Section/AboutZeuss";
import TribeAddress from "./Section/TribeAddress";
import Ecosystem from "./Section/Ecosystem";
import Token from "./Section/Token";
import Tokenomics from "./Section/Tokenomics";
import BuyCrypto from "./Section/BuyCrypto";
import Stories from "./Section/Stories";
import CompareTable from "./Section/CompareTable";
import Faq from "./Section/Faq";
import Launch from "./Section/Launch";
import StripeCheckout from "../Chckeout/Stripe";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json";
const Home = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $TRIBE Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      {/* <StripeCheckout /> */}
      <div className="wrapper">
        <Hero />
        <TribeAddress />
        <AboutZeuss />
        {/* <Ecosystem /> */}
        {/* <Token /> */}
        <Tokenomics />
        <BuyCrypto />
        {/* <CompareTable /> */}
        <Faq />
        {/* <Stories /> */}
        {/* <Launch /> */}
      </div>
    </>
  );
};
export default Home;
